import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { URLS } from '../../constants/URLS';
import { MycontentserviceService } from '../../_service/mycontentservice.service';
import { MycontentComponent } from '../mycontent/mycontent.component';
import { DeleteService } from 'src/app/_service/delete.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { environment } from 'src/environments/environment';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';

@Component({
  selector: 'app-watchhistory',
  templateUrl: './watchhistory.component.html',
  styleUrls: ['./watchhistory.component.css']
})
export class WatchhistoryComponent implements OnInit {

  activeTab: string = 'ccPrime';
  mediaUrl: String = environment.TQR_SERVICE;
  watchHistory: any[] = [];
  isLoading:boolean=false;

  constructor(
    private mycontentservice: MycontentserviceService,
    private toastrService: CustomControlsService
    ) { }

  ngOnInit(): void {
    this.getUserWatchHistoryContents();
  }

  getUserWatchHistoryContents() {
    this.isLoading = true;
    this.mycontentservice.getContinueWatching().subscribe(result => {
      if(result && result.length){
        this.watchHistory = result.map(item => ({
          ...item,
          watchedPercentage: item.progress,
          secondsWatched: item.lastPositionMs / 1000
        }));
        console.log(this.watchHistory)
        this.isLoading=false;
      }
    },(error)=>{
      this.isLoading = false;
    });
  }

  handleMovieAction(event: { movie: any, action: string }) {
    if (event.action === 'remove') {
      this.mycontentservice.deleteWatchHistoryEntry(event.movie.vidLibId).subscribe(() => {
        this.watchHistory = this.watchHistory.filter(m => m.vidLibId !== event.movie.vidLibId);
        this.showSuccess(`Removed from history`);
      });
    }
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  formatWatchSeconds(input: string){
    return Math.floor(Number(input));
  }
}
